import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/fcc3b962-1b4a-416b-be29-4a70ef503f2a",
        "alt": "An image showing different button types."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Buttons allow users to initiate an action or command when clicked. The button's label or text description indicates the purpose of the action to the user. Most of the time, we use the "Default" button type, but other types of buttons may be used to indicate something special about the button's hierarchy or functionality.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/83f703f5-d02c-45f1-82d2-e819613a6638" />
    <Caption mdxType="Caption">Keep button labels succinct with no line breaks.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/e0b67dea-712b-4483-9222-0b499e539415" />
    <Caption mdxType="Caption">
      Buttons should never contain line breaks and lose their button shape.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/96da1bd5-d537-40c1-9103-96254813648f" />
    <Caption mdxType="Caption">Show focus styles on keyboard :focus</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/edc931cf-06ed-4814-8ad0-24a8344902c0" />
    <Caption mdxType="Caption">Don't remove default button :focus styles.</Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/56824212-3622-4546-b437-53dbced734a6" />
    <Caption mdxType="Caption">Use sentence case for labels.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/515e833e-fad2-44fd-aae8-fae6301974c1" />
    <Caption mdxType="Caption">Don't use all-caps or other text formats.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/ef74e834-2650-424e-b382-bdcd4a09c113",
        "alt": "An image showing the different parts of a button with annotations."
      }}></img></p>
    <h2>{`Options`}</h2>
    <h3>{`Variants`}</h3>
    <h4>{`Primary`}</h4>
    <p>{`Primary buttons have top priority in visual hierarchy, and using too many of them on a single view dilutes their effectiveness. We recommend to limit the primary button to one button per view, and place it in the visible section, whenever possible, to indicate its emphasis relative to other actions. Use multiple primary buttons only when the action is repeated in multiple places of the same page. E,g a "Log in" button in the header and in the footer area.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/dfad0124-4cdc-4230-b442-4ee9c747d0f0",
        "alt": "An image showing all primary states."
      }}></img></p>
    <h4>{`Secondary`}</h4>
    <p>{`Secondary buttons are the default button type. Use them for the main actions on a page or form. Secondary buttons are the most common button type and should be used in most cases. They can be paired with a primary button to perform a secondary action, or used on their own.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/71f5a85d-4e63-4a3b-b7fc-2492ceae2b30",
        "alt": "An image showing all secondary states."
      }}></img></p>
    <h4>{`Subtle`}</h4>
    <p>{`Subtle buttons have a transparent background with translucent hover and active states, making them useful for compound components like `}<a parentName="p" {...{
        "href": "/components/ButtonGroup"
      }}>{`Button Group`}</a>{` when paired with secondary or primary variants.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/7420969a-e561-4fd6-9bef-7340e2b0a7e8",
        "alt": "An image showing all subtle states."
      }}></img></p>
    <h4>{`Block`}</h4>
    <p>{`Turning on the block option for button allows the button to span the full width of its container. This feature can be particularly useful when you want the button to occupy more space. Block button can continue to pair with secondary or primary variants.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/2fe48284-7c3d-4262-9992-3fc029237fe6",
        "alt": "An image showing block button with all subtle states."
      }}></img></p>
    <h3>{`Trailing and leading icons`}</h3>
    <p>{`You can place an icon inside the button in either the leading or the trailing position to enhance the visual context. It is recommended to use an use an `}<a parentName="p" {...{
        "href": "https://primer.style/octicons"
      }}>{`Octicon`}</a>{` here.`}</p>
    <p>{`Use a trailing visual if the button action involves selecting items (dropdown, select, filter, etc), and a leading visual to provide visual context to the adjacent label. E.g. Use a search icon for a search field submit action.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/558dd2c0-22b9-4e0b-aa0d-6394eae29e6c" />
    <Caption mdxType="Caption">
      Use a leading icon that provides context and reinforces the label.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/2b4b06e5-5e54-4d8d-885a-b0d3faaa1298" />
    <Caption mdxType="Caption">
      Don't use a trailing icons to add a visual cue to the label. Use the
      leading icon for better scanability.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/5e534c85-0dcd-44b2-8c21-f80f2f14a4d0" />
    <Caption mdxType="Caption">
      Use a trailing icon for select, dropdown, or filter actions to reinforce
      its direction.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/2b3ad072-d3dd-4b34-b7fa-a915fd84d03d" />
    <Caption mdxType="Caption">
      Don't use a leading icon or the arrow for select, dropdown, or filter
      actions.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Size`}</h3>
    <p>{`Button default to a medium size. Medium is suitable for most interfaces and is considered the preferred size.`}</p>
    <p>{`Large buttons increase the significance of an action and should be used sparingly. Use the large option when you need to emphasize the button on a big sized heading, for example in a `}<a parentName="p" {...{
        "href": "/components/Hero"
      }}>{`Hero`}</a>{` component.`}</p>
    <p>{`Small buttons are meant to be used sparingly. Some use cases can be:`}</p>
    <ul>
      <li parentName="ul">{`Contained inside other components like dropdowns or small popups.`}</li>
      <li parentName="ul">{`Areas where very low priority information might display a CTA. `}</li>
      <li parentName="ul">{`Brand presence inside products where information is compact. For example for in-product banner.`}</li>
    </ul>
    <h3>{`Arrow`}</h3>
    <p>{`The arrow is shown by default in all buttons. Hide the arrow only to save horizontal space or to diminish the importance of the button.`}</p>
    <p>{`When used in a group, the arrow should be used or hide consistently across all buttons.`}</p>
    <h2>{`Accessibility`}</h2>
    <h3>{`Descriptive buttons`}</h3>
    <p>{`Labeling buttons properly lets users know what will happen when they activate the control, lessens errors, and increases confidence.`}</p>
    <p>{`Read more about `}<a parentName="p" {...{
        "href": "https://primer.style/design/guides/accessibility/descriptive-buttons/"
      }}>{`descriptive buttons`}</a>{`.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/ButtonGroup"
        }}>{`ButtonGroup`}</a>{`: To display a group of related buttons.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Link"
        }}>{`Link`}</a>{`: To display a link that navigates to another page.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Hero"
        }}>{`Hero`}</a>{`: To display a large heading and a description with a ButtonGroup.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      